import React from 'react'
import { Posts } from '../Components/Posts'

export const Home = () => {
  return (
    <Posts/>
  )
}
